/// <reference path="ConfigurationManagement.js" />
define('viewmodels/configuration/ConfigurationManagement',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings'], function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings) {
    var title = 'Heat Map';

    var ViewModel = {
        activate: activate,
        attached: attached,
        detached: detached,
        title: title,
        appsecurity: appsecurity,
        addPopUpCss: ko.observable(),
        popUpTitle: ko.observable(),
        editableAssessment: ko.observable(),
        editableSurvey: ko.observable(),
        DeleteAssessmentType: DeleteAssessmentType,
        EditAssessmentType: EditAssessmentType,
        OpenConfigureResponseTypePopup: OpenConfigureResponseTypePopup,
        OpenRiskAreaPopup: OpenRiskAreaPopup,
        saveRiskAreaPopUp: saveRiskAreaPopUp,
        AddButtonName: ko.observable(),
        addPopUpCssSurvey: ko.observable(),
        AssessmentTypeListDup: ko.observableArray([]),
        IsEditableField: ko.observable(),
        //clickevents
        TabClick: TabClick,
        OpenAddSurveyPopup: OpenAddSurveyPopup,
        AssessmentTypeAccordionClick: AssessmentTypeAccordionClick,
        SurveyGroupAccordionClick: SurveyGroupAccordionClick,

        //ko.observables()\
        SurveyListModel: ko.observableArray([]),
        AssessmentTypeList: ko.observableArray([]),
        SelectedAssessmentType: ko.observableArray([]),
        SelectedSurveyType: ko.observableArray([]),
        SurveyTypeList: ko.observableArray([]),
        SurveyTypeListDup: ko.observableArray([]),
        popUpTitleSurvey: ko.observable(),
        SaveSurvey: SaveSurvey,
        EditSurvey: EditSurvey,
        DeleteSurveyPopUp: DeleteSurveyPopUp,
        ControlsAccess: ko.observable(false),
        ActionChanged: ActionChanged,
        ObjGeneralSettings: ObjGeneralSettings,
        LocaleCheckFlag: ko.observable(false),
    };
    return ViewModel;


    function activate() {
        try {
            $('#adddivtab').on('click', function () {
            });

            if (ViewModel.ObjGeneralSettings === undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                ViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        ViewModel.LocaleCheckFlag(false);
                    else
                        ViewModel.LocaleCheckFlag(true);
                });
            } else
                ViewModel.LocaleCheckFlag(true);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    };
    function TabClick(data, event) {
        try {
            if (event.currentTarget.id == 'Assesment') {
                $('#addNewDivTab').show();
                $('#addNewSurvey').hide();
                $('#SurveyDiv').hide();
                $('#assessmentDiv').show();
                BindAssessmentmanagementView();
                ViewModel.AddButtonName((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskAssessmentType') == -1) ? 'Add Risk Assessment Type' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskAssessmentType')].Name());
                    //"Add Risk Assessment Type"
            }
            else {
                $('#addNewDivTab').hide();
                $('#addNewSurvey').show();
                $('#SurveyDiv').show();
                $('#assessmentDiv').hide();
                ViewModel.AddButtonName((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewSurvey') == -1) ? 'Add New Survey' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddNewSurvey')].Name());
                BindSurveyManagementView();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function ActionChanged(data, event) {
        try {
            $('#valErrorSurvey').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function BindAssessmentmanagementView() {
        try {
            GetAllAssessmentTypes();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            $("#loadingImgMain").show();
            GetAllAssessmentTypes();
            GetAllSurveyTypes();
            GetallSurveys();

            if (ViewModel.ObjGeneralSettings === undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((ViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && ViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                ViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (ViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || ViewModel.ObjGeneralSettings.LocalizedTextList() == null || ViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || ViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || ViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        ViewModel.LocaleCheckFlag(false);
                    else
                        ViewModel.LocaleCheckFlag(true);
                });
            }

            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        ViewModel.ControlsAccess(true);
                    }
                    else {
                        ViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                ViewModel.ControlsAccess(true);
            }
            else {
                ViewModel.ControlsAccess(false);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function GetAllSurveyTypes() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetAllSurveyTypes",
                type: "GET",
                headers: headers

            })
                .success(function (jsonResult, error) {
                    ViewModel.SurveyTypeList([]);
                    ViewModel.SurveyTypeListDup([]);
                    if (jsonResult.length == 0 || jsonResult[0].Incident_Description == null) {

                        var MappedList = $.map(jsonResult, function (result) {
                            return new SurveyTypeListModel(result);
                        });
                        var MappedListDup = $.map(jsonResult, function (result) {
                            return new SurveyTypeListModel(result);
                        });

                    }

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            var msg = 'An error has occurred while fetching the survey types. Please contact your Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + '-' + msg, 'Error', system.getModuleId(ViewModel), true);
                        }
                    
                    ViewModel.SurveyTypeList(MappedList);
                    ViewModel.SurveyTypeListDup(MappedListDup);
                })
                .fail(function (error, status) {
                    logger.logError('An error has occurred while fetching the survey types. Please contact your Administrator.', 'Error', system.getModuleId(ViewModel), true);
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllSurveyTypes() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function EditAssessmentType(data, event) {
        try {
            var newAssessment = new AssessmentListModel({ AssessmentId: data.AssessmentId(), AssessmentName: data.AssessmentName(), AssessmentDisplayName: data.AssessmentDisplayName(), Description: data.Description() });
            ViewModel.editableAssessment(newAssessment);
            ViewModel.popUpTitle((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditAssessmentDetailsTitle') == -1) ? 'Edit Assessment Type Details' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditAssessmentDetailsTitle')].Name());
            ViewModel.addPopUpCss(false);
            $('#frmAssessment').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditAssessmentType() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function EditSurvey(data, event) {
        try {
            var newSurvey = new SurveyListModel({
                SurveyCategoryId: data.SurveyCategoryId(), SurveyCategoryName: data.SurveyCategoryName(),
                SurveyCategoryShortName: data.SurveyCategoryShortName(),
                SurveyType: data.SurveyType(), Applicability: data.Applicability()
            });
            //var newSurvey = new SurveyListModel({ SurveyCategoryId: data.SurveyCategoryId(), SurveyCategoryName: data.SurveyCategoryName(), SurveyCategoryShortName: data.SurveyCategoryShortName(), SurveyType: data.SurveyType(), Applicability: data.Applicability() });

            if (data.IsEditable() == 0) {
                ViewModel.IsEditableField(true);
            }
            else {
                ViewModel.IsEditableField(false);
            }
            ViewModel.editableSurvey(newSurvey);
            ViewModel.popUpTitleSurvey();
            ViewModel.popUpTitleSurvey((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditComponentDetailsTitle') == -1) ? 'Edit Survey Component Details' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditComponentDetailsTitle')].Name());
                //"Edit Survey Component Details");

            ViewModel.addPopUpCssSurvey(false);
            $('#frmSurvey').modal('show');

            var splitID = $.map(data.AssessmentTypeId().split(","), $.trim);
            ViewModel.SelectedAssessmentType(splitID);
            $("#SurveyAssessmentApplicability").multiselect();
            $("#SurveyAssessmentApplicability").val(splitID);
            $("#SurveyAssessmentApplicability").multiselect('refresh');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditSurvey() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }
    function SaveSurvey(data, event) {
        try {

            if (data.SurveyCategoryName().length == 0 || data.SurveyCategoryName() == "") {
                $('#valErrorSurvey').empty();
                $('#valErrorSurvey').show();
                $('#valErrorSurvey').html((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCNameValidation') == -1) ? 'Survey Component Name cannot be empty.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCNameValidation')].Name());
                    //"Survey Component Name cannot be empty.");

                return false;
            }
            else if (data.SurveyCategoryShortName().length == 0 || data.SurveyCategoryShortName() == "") {
                $('#valErrorSurvey').empty();
                $('#valErrorSurvey').show();
                $('#valErrorSurvey').html((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SSCNameValidation') == -1) ? 'Survey Component Short Name cannot be empty.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SSCNameValidation')].Name());
                    //"Survey Component Short Name cannot be empty.");
                return false;
            }
            else if (data.SurveyType() == undefined) {
                $('#valErrorSurvey').empty();
                $('#valErrorSurvey').show();
                $('#valErrorSurvey').html((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('STypeValidation') == -1) ? 'Survey Type should be selected.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('STypeValidation')].Name());
                    //"Survey Type should be selected.
                return false;
            }
            else if (ViewModel.SelectedAssessmentType().length == 0) {
                $('#valErrorSurvey').empty();
                $('#valErrorSurvey').show();
                $('#valErrorSurvey').html((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MinOneAssessmentType') == -1) ? 'Atleast one Assessment Type should be selected.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MinOneAssessmentType')].Name());
                    //"Atleast one Assessment Type should be selected.
                return false;

            }
            else {
                if (ViewModel.IsEditableField() == false) {
                    for (var i = 0; i < ViewModel.SurveyListModel().length; i++) {

                        if (ViewModel.SurveyListModel()[i].SurveyCategoryName() == data.SurveyCategoryName() &&
                            ViewModel.SurveyListModel()[i].SurveyType() == data.SurveyType() &&
                            ViewModel.SurveyListModel()[i].SurveyCategoryId() != data.SurveyCategoryId()) {

                            for (var j = 0; j < ViewModel.SurveyListModel()[i].ATList().length; j++) {
                                if (ViewModel.SurveyListModel()[i].ATList()[j].ATId() == ViewModel.SelectedAssessmentType()[j]) {

                                    $('#valErrorSurvey').empty();
                                    $('#valErrorSurvey').show();
                                    $('#valErrorSurvey').html((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCAlreadyExists') == -1) ? 'Survey Component with same details already exists.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCAlreadyExists')].Name());
                                        //"Suvey Component with same details already exists."
                                    return false;
                                }
                            }
                        }
                    }
                }
                AddSurvey(data);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function AddSurvey(data) {
        try {
            var selectedassessmetId = "";
            for (var i = 0; i < ViewModel.SelectedAssessmentType().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + ViewModel.SelectedAssessmentType()[i];
                else
                    selectedassessmetId += "|" + ViewModel.SelectedAssessmentType()[i];
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/AddSurveyCategory",
                type: "POST",
                data: {
                    SurveyCategoryId: data.SurveyCategoryId(), SurveyType: data.SurveyType(),
                    SurveyCategoryName: data.SurveyCategoryName(),
                    SurveyCategoryShortName: data.SurveyCategoryShortName,
                    Applicability: selectedassessmetId
                },
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (parseInt(jsonResult) > 0) {
                        $('#frmSurvey').modal('hide');
                        GetallSurveys();
                        logger.logSuccess(
                            //'Survey Component details have been saved successfully.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDetailsSaved') == -1) ? 'Survey Component details have been saved successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDetailsSaved')].Name(), 'Success', system.getModuleId(ViewModel), true);
                    }
                    else {
                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDetailsError') == -1) ? 'Some error occured while saving the Survey. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDetailsError')].Name();
                        //'Some error occured while saving the Survey. Please contact your Administrator.'
                        logger.logError(jsonResult + " - " + msg , 'Error', system.getModuleId(ViewModel), true);
                    }

                })
                .fail(function (jsonResult, error) {
                    logger.logError(
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDetailsError') == -1) ? 'Some error occured while saving the Survey. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDetailsError')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddSurvey() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function DeleteSurveyPopUp(data, event) {
        try {
            app.showMessage('Are you sure you want to delete the Survey Component?', 'Confirm Delete', [' Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-trash btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === ' Confirm') {
                        DeleteSurvey(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteSurveyPopUp() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function DeleteSurvey(data, event) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteSurveyCategory",
                type: "POST",
                data: {
                    SurveyCategoryId: data.SurveyCategoryId
                },
                headers: headers
            })
                .success(function (jsonResult, error) {
                    var neg_code = jsonResult.slice(0, 2);
                    var neg_inc = jsonResult.slice(2, 11);

                    if (parseInt(jsonResult) > 0) {
                        $('#frmSurvey').modal('hide');
                        GetallSurveys();
                        logger.logSuccess(
                            //'Survey Component has been deleted successfully.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteSuccess') == -1) ? 'Survey Component has been deleted successfully.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteSuccess')].Name()
                            , 'Success', system.getModuleId(ViewModel), true);
                    }
                    else if (neg_code == -2)
                    {      //'Survey component cannot be deleted.The questions are configured to this component. Please contact your Administrator.'
                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteFail') == -1) ? 'Survey component cannot be deleted.The questions are configured to this component. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteFail')].Name();
                        logger.logWarning(neg_inc + " - " + msg, 'Error', system.getModuleId(ViewModel), true);
                    }
                    else if (neg_code == -1) {
                          //'Survey component cannot be deleted.The questions are configured to this component. Please contact your Administrator.'
                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteFail') == -1) ? 'Survey component cannot be deleted.The questions are configured to this component. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteFail')].Name();
                        logger.logWarning(neg_inc + " - " + msg, 'Error', system.getModuleId(ViewModel), true);
                    }
                    else {
                          //'Some error occured while deleting the Survey Component. Please contact your Administrator.'
                        $('#deleteSurvey').removeClass('disabled')

                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteError') == -1) ? 'Some error occured while deleting the Survey Component. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteError')].Name();
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(ViewModel), true);
                    }

                })
                .fail(function (jsonResult, error) {
                    logger.logError(
                        //'An error has occurred while deleting Survey. Please contact your Administrator.'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteError') == -1) ? 'Some error occured while deleting the Survey Component. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCDeleteError')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteSurvey() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function DeleteAssessmentType(data, event) {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteAssessmentType() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }
    function GetAllAssessmentTypes() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: headers

            })
                .success(function (jsonResult, error) {
                    ViewModel.AssessmentTypeList([]);
                    ViewModel.AssessmentTypeListDup([]);
                    if (jsonResult.length == 0 || jsonResult[0].Incident_Description == null) {


                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            return new AssessmentListModel(result);
                        });
                        var MappedAssessmentListDup = $.map(jsonResult, function (result) {
                            return new AssessmentListModel(result);
                        });

                    }
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        var msg = 'An error has occurred while fetching the survey types. Please contact your Administrator.';
                        logger.logError(jsonResult[0].Incident_Description + '-' + msg, 'Error', system.getModuleId(ViewModel), true);
                    }
                    var tableobject = $('#AssessmentTypeTable').DataTable();
                    tableobject.destroy();
                    $('#AssessmentTypeTable tbody tr').remove();
                    ViewModel.AssessmentTypeList(MappedAssessmentList);
                    ViewModel.AssessmentTypeListDup(MappedAssessmentListDup);
                    $('#AssessmentTypeTable').DataTable({
                        "bResponsive": true,
                        "stateSave": true,
                        "bPaginate": true,
                        "order": [],
                        "aaSorting": [],
                        "bsortable": false,
                        "aoColumnDefs": [{
                            "aTargets": [3],
                            "bSortable": false
                        }]
                    })
                })
                .fail(function (error, status) {
                    logger.logError(
                        //'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function saveRiskAreaPopUp(data, event) {
        var jsonresult = 0;
        var assessmentname = "";
        for (var i = 0; i < ViewModel.AssessmentTypeList().length; i++) {
            if (data.AssessmentDisplayName() == ViewModel.AssessmentTypeList()[i].AssessmentDisplayName() && data.AssessmentId() != ViewModel.AssessmentTypeList()[i].AssessmentId()) {
                jsonresult = 1;
                assessmentname = data.AssessmentDisplayName()
                break;
            }
            if (data.AssessmentName() == ViewModel.AssessmentTypeList()[i].AssessmentName() && data.AssessmentId() != ViewModel.AssessmentTypeList()[i].AssessmentId()) {
                jsonresult = 1;
                assessmentname = data.AssessmentName()
                break;
            }
        }
        if (jsonresult == 0)
            AddUpdateAssessmentType(data);
        else {
            $('#addassesmenterror').show();
            $('#addassesmenterror').html(assessmentname + ((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeExists') == -1) ? 'Assessment type already exists.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeExists')].Name()));
                //" Assessment type already exists.")
        }
    }

    function AddUpdateAssessmentType(data) {
        try {
            var AssessmentId = parseInt(data.AssessmentId());
            if (AssessmentId == 999) { AssessmentId = null; }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/AddUpdateAssessmentType",
                type: "POST",
                data: { AssessmentId: AssessmentId, AssessmentName: data.AssessmentName(), AssessmentDisplayName: data.AssessmentDisplayName(), Description: data.Description() },
                headers: headers
            })
                .success(function (jsonResult, error) {

                    if (parseInt(jsonResult) > 0)
                        logger.logSuccess('Assessment Type has been sucessfully added/updated.', 'Success', system.getModuleId(ViewModel), true);
                    else if (jsonResult == "0")
                        logger.logSuccess('Assessment Type already exists.', 'Success', system.getModuleId(ViewModel), true);
                    else {
                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the assessment type. Please contact your Administrator.' : 'An error occurred while saving the assessment type details as it contains some invalid characters.';
                        logger.logError(jsonResult + " - " + msg , 'Error', system.getModuleId(ViewModel), true);
                    }

                    $('#frmAssessment').modal('hide');
                    GetAllAssessmentTypes();
                    GetallSurveys();
                })
                .fail(function (error, status) {
                    logger.logError(
                        //'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in saveRiskAreaPopUp() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function DeleteAssessmentType(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/DeleteAssessmentType",
                type: "POST",
                data: { AssessmentId: data.AssessmentId() },
                headers: headers
            })
                .success(function (jsonResult, error) {
                    var neg_code = jsonResult.slice(0, 2);
                    var neg_inc = jsonResult.slice(2, 11);
                    if (jsonResult == 1) {
                        logger.logSuccess(
                            //'Assessment Type has been sucessfully deleted.'
                            (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDeleteSuccess') == -1) ? 'Assessment Type has been sucessfully deleted.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDeleteSuccess')].Name()
                            , 'Success', system.getModuleId(ViewModel), true);
                        GetAllAssessmentTypes();
                    }

                    else if (neg_code == -1) {
                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDependencyDelete') == -1) ? 'This Assessment Type cannot be deleted as it has dependencies. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDependencyDelete')].Name();
                        //'This Assessment Type cannot be deleted as it has dependencies. Please contact your Administrator.'
                        logger.logWarning(neg_inc + " - " + msg, 'Error', system.getModuleId(ViewModel), true);
                    }

                    else {
                        var msg = (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name();
                        // 'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                        logger.logError(jsonResult + " - " + msg, 'Error', system.getModuleId(ViewModel), true);
                    }
                })
                .fail(function (error, status) {
                    logger.logError(//'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }
    function OpenRiskAreaPopup() {
        try {
            $('#addassesmenterror').hide();
            var newAssessment = new AssessmentListModel({ AssessmentId: 999, AssessmentName: "", AssessmentDisplayName: "", Description: "" });
            ViewModel.editableAssessment(newAssessment);
            //ViewModel.popUpTitle("Create New Assessment Type");
            ViewModel.popUpTitle((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NewAssessmentType') == -1) ? 'Create New Assessment Type' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NewAssessmentType')].Name());
            ViewModel.addPopUpCss(true);
            $('#frmAssessment').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaPopup() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function OpenConfigureResponseTypePopup() {
        try {
            ViewModel.popUpTitle((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskAreaDetails') == -1) ? 'Add Risk Area Details' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AddRiskAreaDetails')].Name());
                //"Add Risk Area Details");
            ViewModel.addPopUpCss(true);
            $('#frmAssessment').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenConfigureResponseTypePopup() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }


    function AssessmentTypeAccordionClick(data, event) {
        try {
            if ($('#ATDataDiv').is(':visible')) {
                $('#ATDataDiv').hide();
            }
            else {
                $('#ATDataDiv').show();
            }
        }
        catch (e) {
            var msg = 'exception' + e + 'source in AssessmentTypeAccordionClick() in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }


    function SurveyGroupAccordionClick(data, event) {
        try {
            if ($('#SGDataDiv').is(':visible')) {
                $('#SGDataDiv').hide();
            }
            else {
                $('#SGDataDiv').show();
            }
        }
        catch (e) {
            var msg = 'exception' + e + 'source in SurveyGroupAccordionClick() in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------------------Survey manageemnt View starts here------------------------------------------

    function BindSurveyManagementView() {
        GetallSurveys();
    }

    function GetallSurveys() {
        try {
            var headers = appsecurity.getSecurityHeaders();
            $.ajax({
                url: "/api/Configuration/GetAllSurveyCategories",
                type: "GET",
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description == null) {


                        var MappedSurveyList = $.map(jsonResult, function (result) {
                            return new SurveyListModel(result);
                        });

                        var Surveytableobject = "";
                        Surveytableobject = $('#SurveyCategoryTable').DataTable();
                        Surveytableobject.destroy();
                        $('#SurveyCategoryTable tbody tr').remove();
                        ViewModel.SurveyListModel(MappedSurveyList);
                        $('#SurveyCategoryTable').DataTable({
                            "targets": 'no-sort',
                            "bResponsive": true,
                            "stateSave": true,
                            "bPaginate": true,
                            "order": [],
                            "aaSorting": [],
                            "bsortable": false
                        })
                    }
                    else if (jsonResult.length == 0 && jsonResult != null) {
                        Surveytableobject = $('#SurveyCategoryTable').DataTable();
                        Surveytableobject.destroy();
                        $('#SurveyCategoryTable tbody tr').remove();
                        $('#SurveyCategoryTable').DataTable({
                            "targets": 'no-sort',
                            "bResponsive": true,
                            "stateSave": true,
                            "bPaginate": true,
                            "order": [],
                            "aaSorting": [],
                            "bsortable": false
                        })
                    }

                    else {
                        if (jsonResult == null) {
                            logger.logError(
                                //'Some error occured while deleting the assessment type. Please contact your Administrator.'
                                (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDeleteFail') == -1) ? 'Some error occured while deleting the assessment type. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentTypeDeleteFail')].Name()
                                , 'Error', system.getModuleId(ViewModel), true);
                        }
                        else {
                            var msg = 'An error has occurred while fetching the survey types. Please contact your Administrator.';
                            logger.logError(jsonResult[0].Incident_Description + '-' + msg, 'Error', system.getModuleId(ViewModel), true);
                        }
                    }
                    $("#loadingImgMain").hide();
                })
                .fail(function (error, status) {
                    logger.logError(
                        //'An error has occurred while fetching the type assessments. Please contact your Administrator.'
                        (!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()
                        , 'Error', system.getModuleId(ViewModel), true);
                })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }

    }

    function OpenAddSurveyPopup(data, event) {
        try {
            var newAssessment = new SurveyListModel({
                SurveyCategoryId: -999, SurveyCategoryName: "",
                SurveyCategoryShortName: "", SurveyType: "", Applicability: ""
            });

            ViewModel.SelectedAssessmentType([]);
            var mappedassessmentlist = $.map(ViewModel.AssessmentTypeList(), function (result) {
                return new AssessmentListDupModel(result);
            });
            ViewModel.AssessmentTypeListDup(mappedassessmentlist);
            ViewModel.IsEditableField(false);
            ViewModel.editableSurvey(newAssessment);
            //ViewModel.popUpTitleSurvey("Create New Survey Component");
            ViewModel.popUpTitleSurvey((!ViewModel.LocaleCheckFlag() || ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CreateSurveyComponent') == -1) ? 'Create New Survey Component' : ViewModel.ObjGeneralSettings.LocalizedTextList()[ViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CreateSurveyComponent')].Name());
            ViewModel.addPopUpCssSurvey(true);
            $('#frmSurvey').modal('show');

            $('#SurveyAssessmentApplicability').multiselect();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenAddSurveyPopup() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }
    //------------------------------------------Survey management View ends here---------------------------------------------------
    function SurveyListModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable($('<div/>').html(item.SurveyCategoryId).text());
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable($('<div/>').html(item.SurveyCategoryShortName).text());
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable($('<div/>').html(item.Applicability).text());

            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            if (item.ATModelObj) {
                var MappedList = $.map(item.ATModelObj, function (result) {
                    return new ATListModel(result);
                });
                self.ATList = ko.observableArray(MappedList);
            }

            //var AssessmentId = $.map(item.AssessmentId, function (result) {
            //    return result
            //});
            //self.AssessmentIdList = AssessmentId;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyListModel() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function ATListModel(item) {
        try {
            var self = this;
            self.ATId = ko.observable(item.ATId);
            self.ATName = ko.observable(item.ATName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ATListModel() method in ResponsibilityGroup.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function SurveyTypeListModel(item) {
        try {
            var self = this;
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupName = ko.observable(item.SurveyGroupName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyTypeListModel() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListDupModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
            self.AssessmentName = ko.observable(item.AssessmentName());
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
            self.Description = ko.observable($('<div/>').html(item.Description()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListDupModel() method in ConfigurationManagement.js';
            logger.logMessage(msg);
        }
    }

});

